import React from 'react';
import { compose, withHandlers } from 'recompose';
import { UserForm, refetchTable } from '@kineticdata/react';
import { FormComponents, addToast } from '@kineticdata/bundle-common';
import { PageTitle } from '../shared/PageTitle';
import { Link } from '@reach/router';

export const UserEditComponent = ({
  formKey,
  username,
  handleSave,
  handleDelete,
}) => (
  <div className="page-container">
    <UserForm
      key={username}
      formkey={`user-edit`}
      username={username ? username : null}
      components={{
        FormError: FormComponents.FormError,
        FormButtons: FormComponents.generateFormButtons({
          handleDelete,
          submitLabel: 'Update User',
          cancelPath: '..',
          components: { Link },
        }),
      }}
      alterFields={{
        changePassword: { visible: false },
        password: { visible: false },
        passwordConfirmation: { visible: false },
      }}
      onSave={handleSave}
    >
      {({ form, bindings: { user }, initialized }) =>
        initialized && (
          <div className="page-panel">
            <PageTitle
              parts={['Edit User', 'Users']}
              breadcrumbs={[{ label: 'Users', to: '..' }]}
              title={user && user.get('username')}
            />
            <div className="form-unstyled mb-5">{form}</div>
          </div>
        )
      }
    </UserForm>
  </div>
);

// TODO implement handleDelete?
export const UserEdit = compose(
  withHandlers({
    handleSave: props => () => user => {
      refetchTable(props.tableKey);
      addToast(`${user.username} updated successfully.`);
    },
  }),
)(UserEditComponent);
